import { CDN_URL_ICONS } from '@/configs';
import cs from 'classnames';
import React from 'react';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';
import s from './style.module.scss';

export function LeftArrow({ hidden = false }: { hidden?: boolean }) {
  const { scrollPrev } = React.useContext(VisibilityContext);

  return (
    <div
      className={cs(s.wrapButtonArrow, {
        [`${s.wrapButtonArrow_hidden}`]: hidden,
      })}
    >
      <button
        onClick={() => scrollPrev()}
        className={cs(s.buttonArrowLeft, {})}
      >
        <img alt="prev" src={`${CDN_URL_ICONS}/ic_prev_news.svg`} />
      </button>
    </div>
  );
}

export function RightArrow({ hidden = false }: { hidden?: boolean }) {
  const { scrollNext } = React.useContext(VisibilityContext);
  return (
    <div
      className={cs(s.wrapButtonArrow, {
        [`${s.wrapButtonArrow_hidden}`]: hidden,
      })}
    >
      <button
        onClick={() => scrollNext()}
        className={cs(s.buttonArrowRight, {})}
      >
        <img alt="next" src={`${CDN_URL_ICONS}/ic_next_news.svg`} />
      </button>
    </div>
  );
}
